import React from 'react';

const LearningList = ({ items = [], prefix, limit }) => {
  const visibleItems = Number.isFinite(limit) ? items.slice(0, limit) : items;

  if (!visibleItems.length) return null;

  return (
    <ul className="space-y-2">
      {visibleItems.map((item) => (
        <li key={item} className="flex gap-2">
          <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-blue-500" />
          <span>{prefix && <strong>{prefix}</strong>} {item}</span>
        </li>
      ))}
    </ul>
  );
};

export default LearningList;
